import './customModal.styles.scss'
import { JSX } from 'react'

export interface ModalFooterProps {
  className?: string
  children?: React.ReactNode
  noBorder?: boolean
}

export function ModalFooter({
  className,
  children,
  noBorder,
}: ModalFooterProps): JSX.Element {
  const modalFooterStyle = `modal-footer__content ${className as string} ${
    noBorder ? 'modal-footer__no-border' : ''
  }`
  return <div className={modalFooterStyle}>{children}</div>
}
